import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RowProps } from 'ant-design-vue'
interface IProps extends RowProps {
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    align: {},
    justify: {},
    prefixCls: {},
    gutter: {},
    wrap: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const defaultRowProps = {
  gutter: [8, 8],
  justify: 'space-between'
}

return (_ctx: any,_cache: any) => {
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, _normalizeProps(_guardReactiveProps({
      ...defaultRowProps,
      ...props
    })), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})